export default __webpack_public_path__ + "static/media/invites_illustration.1633fe3f.svg";